module.exports = __webpack_public_path__ + "static/media/Wallet.fd8fe99f.png";